import { gql } from '@apollo/client';

export const GET_PROPERTY_NOTES = gql`
    query PropertyNotes($propertyId: ID!) {
        propertyNotes(propertyId: $propertyId) {
            id
            propertyId
            content
            authorId
            authorName
            authorRole
            isPinned
            createdAt
            updatedAt
        }
    }
`;

export const CREATE_NOTE = gql`
    mutation CreateNote($propertyId: ID!, $content: String!) {
        createNote(propertyId: $propertyId, content: $content) {
            id
            propertyId
            content
            authorId
            authorName
            authorRole
            isPinned
            createdAt
            updatedAt
        }
    }
`;

export const UPDATE_NOTE = gql`
    mutation UpdateNote($noteId: ID!, $content: String!) {
        updateNote(noteId: $noteId, content: $content) {
            id
            content
            updatedAt
        }
    }
`;

export const DELETE_NOTE = gql`
    mutation DeleteNote($noteId: ID!) {
        deleteNote(noteId: $noteId)
    }
`;

export const PIN_NOTE = gql`
    mutation PinNote($noteId: ID!, $isPinned: Boolean!) {
        pinNote(noteId: $noteId, isPinned: $isPinned) {
            id
            isPinned
        }
    }
`;
